import React from 'react';


const PageHeading = ({

   className = 'text-2xl font-semibold mb-6', 
   value
}) => {

    return (
        <h2 className={className}>
       {value}
    </h2>
    );
};

export default PageHeading;